// Vendor libraries
import { signal } from '@angular/core';
// Utils
import { YChartsSentryUtils } from 'NewAngular/services/sentry/sentry-utils';
import * as i0 from "@angular/core";
export class BackgroundJobEventsService {
    constructor() {
        this._eventSource = null;
        this._retryCount = 0;
        this._maxRetries = 5;
        this._baseRetryDelay = 1000;
        this._retryTimeout = null;
        this.jobsInProgress = signal({}, ...(ngDevMode ? [{ debugName: "jobsInProgress" }] : []));
        this.lastTerminalJob = signal(null, ...(ngDevMode ? [{ debugName: "lastTerminalJob" }] : []));
    }
    stream() {
        this._retryCount = 0;
        this.connect();
    }
    connect() {
        const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:3003' : process.env.AI_PROXY_BASE_URL;
        this._eventSource = new EventSource(`${baseUrl}/jobs_progress/${window.USER.userId}`, {
            withCredentials: true,
        });
        this._eventSource.onopen = () => {
            this._retryCount = 0;
        };
        this._eventSource.onmessage = (event) => this.handleProgressUpdate(event);
        this._eventSource.onerror = (e) => {
            this.closeStream();
            if (this._retryCount < this._maxRetries) {
                const delay = this._baseRetryDelay * 2 ** this._retryCount;
                this._retryCount += 1;
                this._retryTimeout = setTimeout(() => {
                    this._retryTimeout = null;
                    this.connect();
                }, delay);
            }
            else {
                YChartsSentryUtils.captureException(e);
                this._retryCount = 0;
            }
        };
    }
    isConnected() {
        return this._eventSource !== null;
    }
    handleProgressUpdate(event) {
        try {
            const update = JSON.parse(event.data);
            if (update.status === 'completed' || update.status === 'failed') {
                this.jobsInProgress.update(({ [update.job_id]: _, ...rest }) => rest);
                this.lastTerminalJob.set(update);
            }
            else {
                this.jobsInProgress.update((jobs) => {
                    const { [update.job_id]: _, ...rest } = jobs;
                    return { [update.job_id]: update, ...rest };
                });
            }
        }
        catch (e) {
            YChartsSentryUtils.captureException(e);
        }
    }
    closeStream() {
        if (this._retryTimeout !== null) {
            clearTimeout(this._retryTimeout);
            this._retryTimeout = null;
        }
        if (this._eventSource !== null) {
            this._eventSource.close();
            this._eventSource = null;
        }
    }
}
BackgroundJobEventsService.ɵfac = function BackgroundJobEventsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BackgroundJobEventsService)(); };
BackgroundJobEventsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BackgroundJobEventsService, factory: BackgroundJobEventsService.ɵfac, providedIn: 'root' });
